import React from 'react';

const CheckNoContent = () => {
    return (
        <div className="text-center mb-3">
            <hr />
            <b style={{ color: "#767676", fontSize: "20px" }}>
                ไม่พบข้อมูล
            </b>
            <hr />
        </div>

    );
};

export default CheckNoContent;
